import React, { useEffect } from "react";
import { RoundCard, RunnerUpHeader, TableWork } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useState } from "react";
import { useGetCountingSupervisorCeoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];

const CountingSupervisorCeoReport = () => {
  
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [data, setData] = useState({
    constituencyType: "AC",
    stateValue: "S01",
  });
  const reportName = "Counting Supervisor Report"
  const SheetName = "Counting Supervisor Report"
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Counting Supervisor Id and Name",
      accessor: "col4",
    },
    {
      Header: "Mobile Number",
      accessor: "col5",
    },
    {
      Header: "Email Id",
      accessor: "col6",
    },
    {
      Header: "Login Status",
      accessor: "col7",
    },
    {
      Header: "Scanning Status",
      accessor: "col8",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const { data: responseData, isLoading: isLoading } = useGetCountingSupervisorCeoReportQuery(data, {
    skip: skip,
    refetchOnMountOrArgChange: true,
  });

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setskip(false);
  };


  useEffect(() => {
    var tableData = [];
    if (responseData != null) {
      responseData?.payload?.map((item) => {
        tableData.push({
          "col1": item.stateName,
          "col2": `${item.districtCd}-${item.districtName}`,
          "col3": `${item.acPcNo}-${item.acPcName}`,
          "col4": `${item.userId}-${item.userName}`,
          "col5": item.mobileNo,
          "col6": item.userEmailId,
          "col7": item.loginStatus==="Y"?"Yes":"No",
          "col8": item.scanningStatus==="Y"?"Started":"Not Started",
        });
      });
      setTabledata(tableData);
      setTotalNoOfRecords(responseData?.payload?.length)
      setskip(true);
    }
  }, [responseData]);

  return (
    <LeftMenu>
    <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName} 
      state={
         <span
                 
                   >
                     State: {responseData?.state}{" "}
                     </span>
         
        } 
       onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata)} 
       onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata)} />
      <div className="row">
        <SelectField
          labelClass=""
          inputClass="col-md-2"
          value={data.constituencyType}
          handleChange={(val) => handleChange("constituencyType", val)}
          options={selectConstituencyType}
        />
      </div>
      <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          records
          tableClassNameCheck="contenttable-eroll"
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
   </LeftMenu>
    
  );
};
export default CountingSupervisorCeoReport;
